import React from 'react';
import PropTypes from 'prop-types';
import MfaPhoneNumberForm from '../../containers/MfaPhoneNumberFormContainer';
import SmsCodeVerificationForm from 'modules/auth/components/SmsCodeVerificationForm';
import TPGrid from 'components/TP-UI/TPGrid';
import TPAlert from 'components/TP-UI/TPAlert';
import TPTypography from 'components/TP-UI/TPTypography';
import { useTranslation } from 'react-i18next';

const EnableSmsCodeMfaForm = ({
  form,
  phoneNumber,
  setupPhoneRequired,
  sendSmsRequired,
  allowResend = true,
  onCodeSent,
  onCodeExpired,
}) => {
  const { t } = useTranslation('auth');

  return setupPhoneRequired ? (
    <MfaPhoneNumberForm form={form} />
  ) : sendSmsRequired ? (
    <TPGrid container spacing={2}>
      <TPGrid item xs={12}>
        <TPAlert variant="info">{t('mfa.sendSMSCodeForm.warning')}</TPAlert>
      </TPGrid>
      <TPGrid item xs={12}>
        <TPTypography gutterBottom>
          {t('mfa.sendSMSCodeForm.description', { phoneNumber })}
        </TPTypography>
      </TPGrid>
    </TPGrid>
  ) : (
    <SmsCodeVerificationForm
      phoneNumber={phoneNumber}
      allowResend={allowResend}
      onCodeSent={onCodeSent}
      onCodeExpired={onCodeExpired}
    />
  );
};

EnableSmsCodeMfaForm.propTypes = {
  form: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string,
  allowResend: PropTypes.bool,
  setupPhoneRequired: PropTypes.bool,
  sendSmsRequired: PropTypes.bool,
  onCodeSent: PropTypes.func,
  onCodeExpired: PropTypes.func,
};

export default EnableSmsCodeMfaForm;
